import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const disbursmentRBAC = {
  pageID: 'd6a4a34e952503ef6ce414e7aea64d8e',
  elementID: {
    ViewDisbursement: '6c6f6e1e0bcdf9360bc724639eaf6492',
    Revise: '263a6707abd010f1ea2cc0452b005a2a',
    UpdateSingleStatus: 'bfedfa130bd30730e63cddf057f60a27',
    UpdateMultipleStatus: '5e681881179d62b424cea25966073a53',
    DownloadDisbursment: 'f9a3ad25f7f7d596f85a3b1e2f7c48ce',
  },
} as const

export const useRBACDisbursmentPage = createUseRBAC(disbursmentRBAC.elementID)

export type UseRBACDisbursmentPageType = ReturnType<typeof useRBACDisbursmentPage>
